import { type RouteConfig } from '../routes.types'

import { sharedRoutes } from './shared.routes'
import { employeeRoutes } from './employee.routes'
import { managerRoutes } from './manager.routes'
import { hrRoutes } from './hr.routes'

/**
 * Private routes organized by role for better maintainability
 * Routes are deduplicated automatically - if multiple role files contain
 * the same route path, only the first one will be used
 */
export const privateRoutes: RouteConfig[] = [...sharedRoutes, ...employeeRoutes, ...managerRoutes, ...hrRoutes].reduce(
    (acc, route) => {
        // Remove duplicates by path to avoid route conflicts
        if (!acc.find((existingRoute) => existingRoute.path === route.path)) {
            acc.push(route)
        }
        return acc
    },
    [] as RouteConfig[],
)
